<template>
  <section class="" style="background: #f6f6f6; color: black">
    <div class="container">
      <div class="section-title page-title" style="padding-bottom: 32px">
        <!--        <div class="mb-5 text-center">-->
        <!--          <div class="capital-label-wrapper">-->
        <!--            &lt;!&ndash; CAPITAL LABEL &ndash;&gt;-->
        <!--            <span class="capital-label">SEE HOW OUR PRODUCTS ARE USED IN YOUR APPLICATIONS</span>-->
        <!--            &lt;!&ndash; CAPITAL LABEL &ndash;&gt;-->
        <!--          </div>-->
        <!--        </div>-->
        <h2
          class="h2-caslon text-black text-center f-44"
          style="font-weight: 600"
        >
          Contact Us
        </h2>
      </div>
    </div>
  </section>
  <!-- PAGE CONTACT US -->
  <section class="page-contact-us bg-primary">
    <div class="container">
      <div class="content">
        <div class="row m-0">
          <div class="col-12 col-md-6 p-0 pt-4 bg-right">
            <div class="content">
              <div class="content">
                <h5 class="page-title">Nagase (Thailand) Co.,Ltd</h5>
              </div>

              <div class="content">
                <div class="contact-item text-white">
                  <i class="fas fa-building"></i>
                  <span
                    >No. 92 Central Park Offices, 10th Floor, Unit No.
                    LL1007-1012, Rama 4 Road, Kwaeng Silom, Khet Bangrak,
                    Bangkok 10500, Thailand</span
                  >
                </div>
              </div>

              <div class="row m-0">
                <div class="col-12 col-md-6 col-xl-4 p-0">
                  <div class="content">
                    <div class="contact-item text-white">
                      <i class="fas fa-phone"></i>
                      <span>Tel 02-825-7000</span>
                    </div>
                    <div class="contact-item text-white">
                      <i class="fas fa-envelope"></i>
                      <span>Fax 02-825-7110</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4 p-0">
                  <div class="content">
                    <div class="contact-item text-white">
                      <i class="fab fa-facebook"></i>
                      <span><a href="#">nagase</a></span>
                    </div>
                    <div class="contact-item text-white">
                      <i class="fab fa-linkedin"></i>
                      <span><a href="#">nagase</a></span>
                    </div>
                    <div class="contact-item text-white d-flex d-xl-none">
                      <i class="fab fa-line"></i>
                      <span><a href="#">nagase</a></span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4 p-0 d-none d-xl-flex">
                  <div class="content">
                    <div class="contact-item text-white">
                      <i class="fab fa-line"></i>
                      <span><a href="#">nagase</a></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 p-0">
            <div class="content">
              <iframe
                class="map"
                height="366"
                loading="lazy"
                allowfullscreen=""
                referrerpolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.8152160278423!2d100.532907015325!3d13.729634590361801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f7c336f64ab%3A0x34c62cc9c7b09c1d!2sNagase(Thailand)Co.%2CLtd.!5e0!3m2!1sth!2sus!4v1669976242497!5m2!1sth!2sus"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="page-contact-us bg-grey">
    <div class="container page-container" style="padding: 0px 0px 0px 10px">
      <div class="content">
        <!-- SECTION TITLE -->
        <h2
          class="section-title h2 text-black h2-caslon"
          style="font-size: 44px"
        >
          Tell us what do you want
        </h2>
        <!-- SECTION TITLE -->

        <p class="section-sub-title" style="padding-left: 2px; font-size: 17px">
          Please click on this link for detail privacy policy :
          <a href="https://www.nagase.co.th/personaldata"
            >https://www.nagase.co.th/personaldata</a
          >
        </p>
        <form id="mktoForm_1446"></form>
        <!-- <form action="">
          <div class="row m-0">
            <div class="col-12 col-lg-7 p-0">
              <fieldset>
                <label for="">Name *</label>
                <input class="form-input-custom" type="text" placeholder="Name">
              </fieldset>
              <fieldset>
                <label for="">Email *</label>
                <input class="form-input-custom" type="text" placeholder="Email">
              </fieldset>
              <fieldset>
                <label for="">Phone *</label>
                <input class="form-input-custom" type="text" placeholder="Phone">
              </fieldset>
              <fieldset>
                <label for="">Message</label>
                <textarea class="form-input-custom" placeholder="Message" rows="4"></textarea>
              </fieldset>
            </div>
          </div>

          <p class="section-sub-title">Please Privacy Policy / Read Nagase Thai -> Compliance Tab ->Nagase (Thailand) Co.,Ltd Personal data Protection Policy) *</p>

          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
            <label class="form-check-label" for="flexCheckDefault">I agree with your Privacy Policy</label>
          </div>

          <button class="btn-submit">Submit</button>
        </form> -->
      </div>
    </div>
  </section>
  <!-- PAGE CONTACT US -->
</template>
<script>
export default {
  mounted() {
    MktoForms2.loadForm("//page.nagase.com", "005-EHC-738", 1446);
    MktoForms2.whenReady((form) => {
      document.querySelector("#mktoForms2BaseStyle").remove();
      document.querySelector("#mktoForms2ThemeStyle").remove();
      const targetForm = form.getFormElem();
      targetForm[0].querySelector("style").remove();

      const fields = [
        {
          name: "FirstName",
          placeholder: "Name",
        },
        {
          name: "Email",
          placeholder: "Email",
        },
        {
          name: "Phone",
          placeholder: "Phone",
        },
        {
          name: "inquiry001",
          placeholder: "Message",
        },
      ];

      fields.forEach((field) => {
        const targetField = targetForm[0].querySelector(
          `[name="${field.name}"]`,
        );
        targetField.setAttribute("placeholder", field.placeholder);
        if (targetField.tagName === "TEXTAREA") {
          targetField.setAttribute("rows", "4");
        }
      });
    });
  },
};
</script>
<script setup>
definePageMeta({
  layout: "contactus",
});

useHead({
  title: "Contact us - NAGASE THAILAND Engineering Plastics",
});
</script>

<style scoped>
.form-input-custom {
  border-radius: 10px;
}
</style>
